import { configureStore } from "@reduxjs/toolkit";
import authReducer from './main/authSlice.js';
import accountReducer from './main/accountSlice.js';
import userReducer from './main/userSlice.js';
import sidebarReducer from './sidebarSlice.js';
import uiReducer from './main/uiSlice.js';
import rightModalReducer from './rightModalSlice.js';
import customersReducer from './customers/customersSlice.js';
import customerDetailsReducer from './customers/customerDetailsSlice.js';
import systemsReducer from './systems/systemsSlice.js';
import systemDetailsReducer from './systems/systemDetailsSlice.js';
import assistanceRequestsReducer from './assistanceRequests/assistanceRequestsSlice.js';
import usersReducer from './users/usersSlice.js';
import userDetailsReducer from './users/userDetailsSlice.js';
import servicesReducer from './services/servicesSlice.js';
import serviceDetailsReducer from './services/serviceDetailsSlice.js';
import equipmentReducer from './equipment/equipmentSlice.js';
import internalVehicleReducer from './internalVehicle/internalVehicleSlice.js';
import customerInteractionsReducer from './customerInteractions/customerInteractionsSlice.js';
import jobsReducer from './jobs/jobsSlice.js';
import suppliersReducer from './suppliers/suppliersSlice.js';
import productsReducer from './products/productsSlice.js';
import productMovementsReducer from './productMovements/productMovementsSlice.js';
import tempWarehouseReducer from './tempWarehouse/tempWarehouseSlice.js';
import warehouseReducer from './warehouse/warehouseSlice.js';
import productCategoryReducer from './productCategory/productCategorySlice.js';
import carriersReducer from './carriers/carriersSlice.js';
import maintenancesReducer from './maintenances/maintenancesSlice.js';
import billedJobsReducer from './billedJobs/billedJobsSlice.js';
import jobWizardReducer from './jobWizard/jobWizardSlice.js';
import agentsReducer from './agents/agentsSlice.js';
import supplierOrdersReducer from './supplierOrders/supplierOrdersSlice.js';
import productSettingsReducer from './productSettings/productSettingsSlice.js';
import leadsReducer from './leads/leadsSlice.js';
import quotationsReducer from './quotations/quotationsSlice.js';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        account: accountReducer,
        user: userReducer,
        sidebar: sidebarReducer,
        ui: uiReducer,
        rightModal: rightModalReducer,
        customers: customersReducer,
        customerDetails: customerDetailsReducer,
        systems: systemsReducer,
        systemDetails: systemDetailsReducer,
        assistanceRequests: assistanceRequestsReducer,
        users: usersReducer,
        userDetails: userDetailsReducer,
        services: servicesReducer,
        serviceDetails: serviceDetailsReducer,
        equipment: equipmentReducer,
        internalVehicle: internalVehicleReducer,
        customerInteractions: customerInteractionsReducer,
        jobs: jobsReducer,
        suppliers: suppliersReducer,
        products: productsReducer,
        productMovements: productMovementsReducer,
        tempWarehouse: tempWarehouseReducer,
        warehouse: warehouseReducer,
        productCategory: productCategoryReducer,
        carriers: carriersReducer,
        maintenances: maintenancesReducer,
        billedJobs: billedJobsReducer,
        jobWizard: jobWizardReducer,
        agents: agentsReducer,
        supplierOrders: supplierOrdersReducer,
        productSettings: productSettingsReducer,
        leads: leadsReducer,
        quotations: quotationsReducer
    }
})
